"use client";

import { LoadingArea } from "@ui/loading";
import dynamic from "next/dynamic";
import { KCPostViewProps } from "./post-view";

const KCPostView = dynamic(() => import("./post-view"), {
  ssr: false,
  loading: () => <LoadingArea h="100vh" w="full" />,
});

export const KCPost = (props: KCPostViewProps) => {
  return <KCPostView {...props} />;
};
